import React from "react";
import "./why_manet.css";
import { cardData } from "../../cardData";

const WhyManet = () => {
  return (
    <section className="whymanet-section">
      <h1  className="title">Why Choose MANET?</h1>
      <h2  className="subtitle">
        MANET equips future leaders with world-class training and global opportunities
      </h2>

      <div className="whymanet-cards-grid">
        {cardData.map((card, index) => (
          <div key={index} className="whymanet-card">
            <img src={card.logo} alt={card.title} className="whymanet-logos" />
            <p>{card.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyManet;
